/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ guard: NonNullable<unknown> }} Automation_Guard_LabelInputs */

const en_automation_guard_label = /** @type {(inputs: Automation_Guard_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.guard === "canAdvance") return /** @type {LocalizedString} */ (`Requirements for the next step are met`);
	if (i?.guard === "missingRequiredDocuments") return /** @type {LocalizedString} */ (`Required documents are missing`);
	if (i?.guard === "missingStepFields") return /** @type {LocalizedString} */ (`Fields required by the next step are missing`);
	if (i?.guard === "fieldsIncomplete") return /** @type {LocalizedString} */ (`Case creation fields are incomplete`);
	if (i?.guard === "onlyRecommendedDocumentsMissing") return /** @type {LocalizedString} */ (`Only recommended documents are missing`);
	if (i?.guard === "documentsGateCaseStep") return /** @type {LocalizedString} */ (`Request is tied to a step advance`);
	if (i?.guard === "documentsSatisfyTargetStep") return /** @type {LocalizedString} */ (`Documents provided and step requirements met`);
	if (i?.guard === "documentsLetNewCaseStartAnalysis") return /** @type {LocalizedString} */ (`Documents let a new case start analysis`);
	if (i?.guard === "exceptionLetsNewCaseStartAnalysis") return /** @type {LocalizedString} */ (`Exception approved for a new case to start analysis`);
	if (i?.guard === "documentsLeaveStepFieldsMissing") return /** @type {LocalizedString} */ (`Documents provided but step fields are missing`);
	if (i?.guard === "documentsLeaveCreationFieldsMissing") return /** @type {LocalizedString} */ (`Documents provided but creation fields are incomplete`);
	return /** @type {LocalizedString} */ (`${i?.guard}`)
	
};

const pt_br2_automation_guard_label = /** @type {(inputs: Automation_Guard_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.guard === "canAdvance") return /** @type {LocalizedString} */ (`Requisitos da próxima etapa atendidos`);
	if (i?.guard === "missingRequiredDocuments") return /** @type {LocalizedString} */ (`Faltam documentos obrigatórios`);
	if (i?.guard === "missingStepFields") return /** @type {LocalizedString} */ (`Faltam campos exigidos pela próxima etapa`);
	if (i?.guard === "fieldsIncomplete") return /** @type {LocalizedString} */ (`Campos de criação do caso incompletos`);
	if (i?.guard === "onlyRecommendedDocumentsMissing") return /** @type {LocalizedString} */ (`Faltam apenas documentos recomendados`);
	if (i?.guard === "documentsGateCaseStep") return /** @type {LocalizedString} */ (`Solicitação vinculada a avanço de etapa`);
	if (i?.guard === "documentsSatisfyTargetStep") return /** @type {LocalizedString} */ (`Documentos enviados e requisitos da etapa atendidos`);
	if (i?.guard === "documentsLetNewCaseStartAnalysis") return /** @type {LocalizedString} */ (`Documentos liberam análise de caso novo`);
	if (i?.guard === "exceptionLetsNewCaseStartAnalysis") return /** @type {LocalizedString} */ (`Exceção aprovada para caso novo iniciar análise`);
	if (i?.guard === "documentsLeaveStepFieldsMissing") return /** @type {LocalizedString} */ (`Documentos enviados, mas faltam campos da etapa`);
	if (i?.guard === "documentsLeaveCreationFieldsMissing") return /** @type {LocalizedString} */ (`Documentos enviados, mas campos de criação incompletos`);
	return /** @type {LocalizedString} */ (`${i?.guard}`)
	
};

/**
* | guard | output |
* | --- | --- |
* | "canAdvance" | "Requirements for the next step are met" |
* | "missingRequiredDocuments" | "Required documents are missing" |
* | "missingStepFields" | "Fields required by the next step are missing" |
* | "fieldsIncomplete" | "Case creation fields are incomplete" |
* | "onlyRecommendedDocumentsMissing" | "Only recommended documents are missing" |
* | "documentsGateCaseStep" | "Request is tied to a step advance" |
* | "documentsSatisfyTargetStep" | "Documents provided and step requirements met" |
* | "documentsLetNewCaseStartAnalysis" | "Documents let a new case start analysis" |
* | "exceptionLetsNewCaseStartAnalysis" | "Exception approved for a new case to start analysis" |
* | "documentsLeaveStepFieldsMissing" | "Documents provided but step fields are missing" |
* | "documentsLeaveCreationFieldsMissing" | "Documents provided but creation fields are incomplete" |
* | * | "{guard}" |
*
* @param {Automation_Guard_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_guard_label = /** @type {((inputs: Automation_Guard_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Guard_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_guard_label(inputs)
	return pt_br2_automation_guard_label(inputs)
});